import ModelUpdate from "@/models/ModelUpdate";
import {ICategoryAdmin} from "@/models/category/CategoryAdminModels";
import {ValidationRule} from "@/declarations/ValidationRule";
import TranslatedValueUpdate from "@/models/translated-value/TranslatedValueUpdate";

export default class CategoryUpdateCarouselDescription extends ModelUpdate<ICategoryAdmin> {

	public carouselDescription!: TranslatedValueUpdate;

	public constructor(model: ICategoryAdmin) {
		super();
		this.setDetailModel(model);
	}

	protected initializeWithDetailModelData(detailModel: ICategoryAdmin): void {
		this.carouselDescription = new TranslatedValueUpdate(detailModel.carouselDescription);
	}

	public rules(): ValidationRule[] {
		return [];
	}

}
